module.exports = __webpack_public_path__ + "img/take-away.7c041bab.svg";